<div class="app">
  <header class="app__hero">
    <div class="app__hero-header">
      <div class="app__hero-body">
        <h1>Kompta</h1>
      </div>
      <div class="mobile-account-picker">
        <label for="mobile-account">Compte</label>
        <div class="mobile-account-picker__row">
          <select id="mobile-account" [ngModel]="compteSelectionne()?.id ?? null"
            (ngModelChange)="selectionnerCompteParId($event)" [disabled]="comptes().length === 0">
            <option [ngValue]="null" disabled>Choisir un compte</option>
            @for (compte of comptes(); track compte.id) {
              <option [ngValue]="compte.id">{{ libelleCompteMobile(compte.nom) }}</option>
            }
          </select>
          @if (comptes().length === 0) {
          <button type="button" class="mobile-account-picker__manage" (click)="basculerAffichageComptes()"
            [attr.aria-expanded]="afficherComptes()" aria-label="Gérer les comptes" title="Gérer les comptes">
            <i class="ph-fill ph-gear" aria-hidden="true"></i>
          </button>
          }
        </div>
      </div>
      <div class="app__hero-user">
        <span class="user-name">👤 {{ currentUserName }}</span>
        <button class="btn-admin" (click)="goToAdmin()" title="Panneau admin" aria-label="Panneau admin">
          <span class="user-action-label">⚙️ Admin</span><i class="ph ph-gear user-action-icon" aria-hidden="true"></i>
        </button>
        <button class="btn-logout" (click)="logout()" title="Déconnexion" aria-label="Déconnexion">
          <span class="user-action-label">🔓 Déconnexion</span><i class="ph ph-sign-out user-action-icon" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="app__lead app__lead--inline">
      <p>
        @if (compteSelectionne(); as compte) {
          <span class="compte-selectionne-header">
            <a
              class="lien-banque-header"
              href="https://www.icgauth.caisse-epargne.fr/se-connecter/identifier"
              target="_blank"
              rel="noopener noreferrer"
              title="Ouvrir Caisse d'Épargne"
              aria-label="Ouvrir Caisse d'Épargne"
              >
              <img
                src="assets/CE.jpg"
                alt=""
                width="22"
                height="22"
                />
              </a>
              <span>{{ compte.nom || 'ce compte' }}</span>
            </span>
          } @else {
            Sélectionnez un compte pour afficher vos prévisions mensuelles.
          }
        </p>
        <div class="app__hero-tags">
          <div class="periode">
            <button type="button" (click)="periodePrecedente()">&#8249;</button>
          </div>
          <span class="badge">Période {{ periode().mois | number: '2.0' }}/{{ periode().annee }}</span>
          <div class="periode">
            <button type="button" (click)="periodeSuivante()">&#8250;</button>
          </div>
          <button type="button" class="btn-secondaire" (click)="periodeCourante()">Aujourd'hui</button>
          <button type="button" class="btn-secondaire" (click)="basculerAffichageComptes()">
            {{ afficherComptes() ? 'Masquer Comptes' : 'Comptes' }}
          </button>
          <button type="button" class="btn-secondaire" [class.btn-vue-actif]="vueActive() === 'detail'"
            (click)="activerVue('detail')">
            📋 Détail
          </button>
          <button type="button" class="btn-secondaire" [class.btn-vue-actif]="vueActive() === 'budget'"
            (click)="activerVue('budget')">
            📅 Plan annuel
          </button>
          @if (compteSelectionne()?.derniereMaj) {
            <small class="derniere-maj-header">
              Dernière action: {{ formatterDate(compteSelectionne()!.derniereMaj) }}
            </small>
          }
        </div>
      </div>
      <div class="app__hero-stats">
        @if (compteSelectionne(); as compte) {
          <article class="hero-stat hero-stat--solde-edit">
            <p>Solde du compte actuel
              <button type="button" class="btn-edit-solde" (click)="editeSolde.set(!editeSolde())"
                [title]="editeSolde() ? 'Annuler' : 'Modifier le solde'">
                @if (!editeSolde()) {
                  <i class="ph-fill ph-pencil-simple" aria-hidden="true"></i>
                }
                @if (editeSolde()) {
                  <i class="ph-fill ph-x" aria-hidden="true"></i>
                }
              </button>
            </p>
            @if (!editeSolde()) {
              <strong>{{ formatterMontant(compte.soldeActuel ?? compte.soldeInitial) }}</strong>
              <small>CB différée {{ formatterMontant(compte.soldeCBDiffere ?? 0) }}</small>
            }
            @if (editeSolde()) {
              <form [formGroup]="soldeActuelForm" (ngSubmit)="mettreAJourSoldeActuel(); soldeActuelForm.valid && editeSolde.set(false)"
                class="formulaire formulaire--hero-solde">
                <input type="text" appMontant formControlName="soldeActuel" aria-label="Solde actuel" />
                <button type="submit" class="btn-valider-hero-solde" title="Valider"><i class="ph-fill ph-check"
                aria-hidden="true"></i></button>
              </form>
              <div class="hero-solde-cb">
                <small>CB diff. :</small>
                <form [formGroup]="soldeCBDiffereForm" (ngSubmit)="mettreAJourSoldeCBDiffere(); soldeCBDiffereForm.valid && editeSolde.set(false)"
                  class="formulaire formulaire--hero-solde formulaire--hero-solde-sm">
                  <input type="text" appMontant formControlName="soldeCBDiffere" aria-label="CB différée" />
                  <button type="submit" class="btn-valider-hero-solde btn-valider-hero-solde--sm" title="Valider"><i
                  class="ph-fill ph-check" aria-hidden="true"></i></button>
                </form>
              </div>
            }
          </article>
          @if (operationsPlanifiees().length || operationsReelles().length) {
            <article class="hero-stat hero-stat--ghost">
              <p>Activité réalisées</p>
              <strong>{{ formatterMontant(soldeOperationsReelles(true)) }}</strong>
              <small>Entrée : +{{ formatterMontant(TotalOperationsReelles(true, false)) }}</small>
              <small>Sortie : {{ formatterMontant(TotalOperationsReelles(true, true)) }} </small>
            </article>
          }
        }
        @if (prevision(); as detailPrevision) {
          <article class="hero-stat hero-stat">
            <p>Opérations restantes {{ operationsPlanifiees().length + nombreOperationsReellesNonPointees() }}/{{
            operationsPlanifiees().length + operationsReelles().length }}</p>
            <strong>{{ formatterMontant(soldeBudgetNet(detailPrevision)) }}</strong>
            <small>Entrée : +{{ formatterMontant(montantRestantPlanifie(detailPrevision, 'ENTREE') +
              TotalOperationsReelles(false,
            false)) }}</small>
            <small>Sortie : -{{ formatterMontant(montantRestantPlanifie(detailPrevision, 'SORTIE') -
            TotalOperationsReelles(false, true)) }} </small>
          </article>
          <article class="hero-stat">
            <p>Solde prévu fin de mois</p>
            <strong>{{ formatterMontant(soldePlanifieFinDeMois(detailPrevision)) }}</strong>
            <small>Entrée intiales : +{{ formatterMontant(detailPrevision.planifie.entrees) }}</small>
            <small>Sortie initiales : -{{ formatterMontant(detailPrevision.planifie.sorties) }} </small>
          </article>
        }
      </div>
    </header>

    @if (erreurs() || succes()) {
      <section class="messages" aria-live="polite">
        @if (erreurs()) {
          <p class="alerte alerte--erreur">{{ erreurs() }}</p>
        }
        @if (succes()) {
          <p class="alerte alerte--succes">{{ succes() }}</p>
        }
      </section>
    }

    @if (afficherComptes()) {
      <div class="top-panel">
        <section class="top-panel__comptes volet">
          <header class="volet__header">
            <div>
              <h2>Choisissez un compte</h2>
            </div>
            <div class="volet__actions">
              <button type="button" (click)="ouvrirCreationCompte()">+ Nouveau compte</button>
            </div>
          </header>
          @if (comptes().length > 0) {
            <ul class="liste-comptes">
              @for (compte of comptes(); track compte) {
                <li [class.selectionne]="compteSelectionne()?.id === compte.id">
                  <div class="compte-ligne">
                    <button type="button" (click)="selectionnerCompte(compte)">
                      <span class="compte-infos">
                        <span class="nom">{{ compte.nom }}</span>
                      </span>
                      <span class="montant">
                        <strong>{{ formatterMontant(compte.soldeActuel ?? compte.soldeInitial) }}</strong>
                        @if ((compte.soldeCBDiffere ?? 0) !== 0) {
                          <small class="montant__cb">
                            {{ formatterMontant(compte.soldeCBDiffere ?? 0) }}
                          </small>
                        }
                      </span>
                    </button>
                    <div class="compte-actions">
                      <button type="button" class="btn-secondaire" (click)="editerCompte(compte)">Modifier</button>
                      @if (compte.derniereMaj) {
                        <small class="derniere-maj">
                          Dernière action: {{ formatterDate(compte.derniereMaj) }}
                        </small>
                      }
                    </div>
                  </div>
                </li>
              }
            </ul>
          } @else {
            <div class="empty-state">
              <h3>Aucun compte pour l'instant</h3>
              <p>Ajoutez votre premier compte pour débloquer la prévision de trésorerie.</p>
              <button type="button" (click)="ouvrirCreationCompte()">Créer un compte</button>
            </div>
          }
          <!-- Canvas modal for create/edit compte -->
          @if (compteFormOuverte()) {
            <div class="canvas-pointage">
              <div class="canvas-pointage__overlay" (click)="annulerEditionCompte()"></div>
              <div class="canvas-pointage__panel canvas-operation-reelle__panel" role="dialog" aria-modal="true">
                <div class="canvas-operation-reelle__header">
                  <h3>{{ compteEditee() ? 'Modifier le compte' : 'Ajouter un compte' }}</h3>
                  <button type="button" class="canvas-operation-reelle__close" aria-label="Fermer"
                  (click)="annulerEditionCompte()">&times;</button>
                </div>
                <form [formGroup]="compteForm" (ngSubmit)="creerCompte()" class="formulaire formulaire--vertical">
                  <label>
                    Nom du compte
                    <input type="text" formControlName="nom" />
                  </label>
                  <label>
                    Solde initial / actuel
                    <input type="text" appMontant formControlName="soldeInitial" />
                  </label>
                  <label>
                    Solde CB différé
                    <input type="text" appMontant formControlName="soldeCBDiffere" />
                  </label>
                  <div class="form-actions">
                    <button type="submit">{{ compteEditee() ? 'Mettre à jour' : 'Créer' }}</button>
                    <button type="button" class="btn-secondaire" (click)="annulerEditionCompte()">Annuler</button>
                  </div>
                </form>
              </div>
            </div>
          }
        </section>
      </div>
    }

    @if (compteSelectionne(); as compte) {
      <div class="layout">
        <main class="contenu">
          <!-- Popup création/édition opération planifiée — disponible sur toutes les vues -->
          <app-popup-edition-planifiee [operation]="operationPlanifieeEditee()" [visible]="operationPlanifieeFormOuverte()" [erreur]="erreurs()"
            [categories]="categories()" [moyensPaiement]="moyensPaiement"
            [comptesDisponibles]="comptesDestinationDisponibles()" (sauvegarder)="onSauvegarderPlanifiee($event)"
            (annuler)="fermerCanvasOperationPlanifiee()" (supprimer)="supprimerOperationPlanifiee($event)"
          (ajouterCategorie)="ajouterCategorie()"></app-popup-edition-planifiee>
          <!-- Vue Plan annuel -->
          @if (vueActive() === 'budget' || modeTelephone()) {
            <app-plan-annuel [compte]="compteSelectionne()" [categories]="categories()"
              [comptesDisponibles]="comptesDestinationDisponibles()" [refreshToken]="planAnnuelRefreshToken()"
              (ouvrirCreation)="ouvrirCreationOperationPlanifiee()" (operationModifiee)="rechargerPeriodeCourante()"
            (ajouterCategorie)="ajouterCategorie()"></app-plan-annuel>
          }
          @if (vueActive() === 'detail' && !modeTelephone()) {
            <section class="operations">
              <div class="operations__colonne">
                <div class="operations__header">
                  <div>
                    <h2>Opérations planifiées</h2>
                  </div>
                  <div class="operations__header-actions">
                    <button type="button" (click)="ouvrirCreationOperationPlanifiee()">
                      Ajouter une opération planifiée
                    </button>
                  </div>
                </div>
                @if (chargementPlanifiees()) {
                  <div class="skeleton">Chargement…</div>
                }
                <app-popup-pointage-planifiee [operation]="operationPlanifieeAPointer()"
                  [montantInitial]="montantPointagePropose()"
                  [operationsReelles]="operationsReellesPourOperation(operationPlanifieeAPointer()?.id ?? 0)"
                  [totalReelles]="totalOperationsReelles(operationPlanifieeAPointer()?.id ?? 0)"
                  [operationsNonPointees]="operationsNonPointeesPourProvision(operationPlanifieeAPointer()?.id ?? 0)"
                  [enregistrement]="enregistrementProvision()" [erreur]="erreurs()"
                  (ajouterNonPointee)="onAjouterOperationProvision($event)"
                  (pointerOperation)="onPointerOperationProvision($event)"
                  (reporterOperation)="onReporterOperationProvision($event)"
                  (supprimerOperation)="onSupprimerOperationProvision($event)"
                  (depointerOperation)="onDepointerOperationProvision($event)"
                  [moyensPaiement]="moyensPaiement" [comptesDisponibles]="comptesDestinationDisponibles()"
                  (confirmer)="onConfirmerPointagePlanifiee($event)"
                (annuler)="annulerPointageOperationPlanifiee()"></app-popup-pointage-planifiee>
                @if (operationsPlanifieesTrieesEtFiltrees().length > 0) {
                  <div class="table-wrapper"
                    (click)="fermerTousLesDropdowns()">
                    <table class="tableau" (click)="$event.stopPropagation()">
                      <thead>
                        <tr>
                          <th class="th-filtrable">
                            <div class="th-header" (click)="$event.stopPropagation()">
                              <span (click)="changerTriPlanifiee('libelle')" class="th-triable">
                                Libellé
                                @if (triPlanifieeColonne() === 'libelle') {
                                  <span class="tri-icone">
                                    {{ triPlanifieeOrdre() === 'asc' ? '▲' : '▼' }}
                                  </span>
                                }
                              </span>
                              <button type="button" class="btn-filtre-colonne" [class.actif]="nombreFiltresLibelle() > 0"
                                (click)="basculerDropdownColonne('libelle')">
                                🔍
                                @if (nombreFiltresLibelle() > 0) {
                                  <span class="badge-filtre">{{ nombreFiltresLibelle()
                                  }}</span>
                                }
                              </button>
                            </div>
                            @if (colonneDropdownOuverte() === 'libelle') {
                              <div class="dropdown-filtre"
                                (click)="$event.stopPropagation()">
                                <div class="dropdown-filtre__content">
                                  <input type="text" placeholder="Rechercher..." [value]="filtreLibelleTexte()"
                                    (input)="filtreLibelleTexte.set($any($event.target).value)"
                                    (keydown.enter)="fermerTousLesDropdowns()" class="dropdown-filtre__input" />
                                    <button type="button" class="dropdown-filtre__reset"
                                      (click)="reinitialiserFiltreColonne('libelle')" [disabled]="nombreFiltresLibelle() === 0">
                                      Réinitialiser
                                    </button>
                                  </div>
                                </div>
                              }
                            </th>
                            <th class="th-filtrable">
                              <div class="th-header">
                                <span (click)="changerTriPlanifiee('montant')" class="th-triable">
                                  Montant
                                  @if (triPlanifieeColonne() === 'montant') {
                                    <span class="tri-icone">
                                      {{ triPlanifieeOrdre() === 'asc' ? '▲' : '▼' }}
                                    </span>
                                  }
                                </span>
                                <button type="button" class="btn-filtre-colonne" [class.actif]="nombreFiltresMontant() > 0"
                                  (click)="basculerDropdownColonne('montant')">
                                  🔍
                                  @if (nombreFiltresMontant() > 0) {
                                    <span class="badge-filtre">{{ nombreFiltresMontant()
                                    }}</span>
                                  }
                                </button>
                              </div>
                              @if (colonneDropdownOuverte() === 'montant') {
                                <div class="dropdown-filtre"
                                  (click)="$event.stopPropagation()">
                                  <div class="dropdown-filtre__content">
                                    <label>
                                      <span>Min</span>
                                      <input type="text" appMontant placeholder="Montant min" [ngModel]="filtreMontantMin()" [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="filtreMontantMin.set($event)"
                                        (keydown.enter)="fermerTousLesDropdowns()" />
                                      </label>
                                      <label>
                                        <span>Max</span>
                                        <input type="text" appMontant placeholder="Montant max" [ngModel]="filtreMontantMax()" [ngModelOptions]="{standalone: true}"
                                          (ngModelChange)="filtreMontantMax.set($event)"
                                          (keydown.enter)="fermerTousLesDropdowns()" />
                                        </label>
                                        <label>
                                          <span>Type</span>
                                          <select [value]="filtreMontantType()"
                                            (change)="filtreMontantType.set($any($event.target).value)"
                                            (keydown.enter)="fermerTousLesDropdowns()">
                                            <option value="TOUS">● Tous</option>
                                            <option value="ENTREE">○ Entrées</option>
                                            <option value="SORTIE">○ Sorties</option>
                                          </select>
                                        </label>
                                        <button type="button" class="dropdown-filtre__reset"
                                          (click)="reinitialiserFiltreColonne('montant')" [disabled]="nombreFiltresMontant() === 0">
                                          Réinitialiser
                                        </button>
                                      </div>
                                    </div>
                                  }
                                </th>
                                <!--
                                <th>Type</th>
                                <th>Provision</th>
                                <th>Restant</th>-->
                                <th class="th-filtrable">
                                  <div class="th-header">
                                    <span (click)="changerTriPlanifiee('jour')" class="th-triable">
                                      Jour
                                      @if (triPlanifieeColonne() === 'jour') {
                                        <span class="tri-icone">
                                          {{ triPlanifieeOrdre() === 'asc' ? '▲' : '▼' }}
                                        </span>
                                      }
                                    </span>
                                    <button type="button" class="btn-filtre-colonne" [class.actif]="nombreFiltresJour() > 0"
                                      (click)="basculerDropdownColonne('jour')">
                                      🔍
                                      @if (nombreFiltresJour() > 0) {
                                        <span class="badge-filtre">{{ nombreFiltresJour() }}</span>
                                      }
                                    </button>
                                  </div>
                                  @if (colonneDropdownOuverte() === 'jour') {
                                    <div class="dropdown-filtre"
                                      (click)="$event.stopPropagation()">
                                      <div class="dropdown-filtre__content">
                                        <input type="number" placeholder="Jour du mois (1-31)" min="1" max="31"
                                          [value]="filtreJour() ?? ''" (input)="filtreJour.set(parseNumber($any($event.target).value))"
                                          (keydown.enter)="fermerTousLesDropdowns()" class="dropdown-filtre__input" />
                                          <button type="button" class="dropdown-filtre__reset"
                                            (click)="reinitialiserFiltreColonne('jour')" [disabled]="nombreFiltresJour() === 0">
                                            Réinitialiser
                                          </button>
                                        </div>
                                      </div>
                                    }
                                  </th>
                                  <th class="th-filtrable">
                                    <div class="th-header">
                                      <span (click)="changerTriPlanifiee('categorie')" class="th-triable">
                                        Catégorie
                                        @if (triPlanifieeColonne() === 'categorie') {
                                          <span class="tri-icone">
                                            {{ triPlanifieeOrdre() === 'asc' ? '▲' : '▼' }}
                                          </span>
                                        }
                                      </span>
                                      <button type="button" class="btn-filtre-colonne" [class.actif]="nombreFiltresCategorie() > 0"
                                        (click)="basculerDropdownColonne('categorie')">
                                        🔍
                                        @if (nombreFiltresCategorie() > 0) {
                                          <span class="badge-filtre">{{ nombreFiltresCategorie()
                                          }}</span>
                                        }
                                      </button>
                                    </div>
                                    @if (colonneDropdownOuverte() === 'categorie') {
                                      <div class="dropdown-filtre"
                                        (click)="$event.stopPropagation()">
                                        <div class="dropdown-filtre__content">
                                          <input type="text" placeholder="Rechercher..." [value]="filtreCategorieTexte()"
                                            (input)="filtreCategorieTexte.set($any($event.target).value)"
                                            (keydown.enter)="fermerTousLesDropdowns()" class="dropdown-filtre__input" />
                                            <button type="button" class="dropdown-filtre__reset"
                                              (click)="reinitialiserFiltreColonne('categorie')" [disabled]="nombreFiltresCategorie() === 0">
                                              Réinitialiser
                                            </button>
                                          </div>
                                        </div>
                                      }
                                    </th>
                                    <th class="col-actions">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (operation of operationsPlanifieesTrieesEtFiltrees(); track operation) {
                                    <tr
                                      [class.en-edition]="operationPlanifieeEditee()?.id === operation.id"
                                      [class.est-reelle]="operation.estReelle">
                                      <td>
                                        <span class="type-chip" [class.type-chip--entree]="operation.type === 'ENTREE'"
                                          [class.type-chip--sortie]="operation.type === 'SORTIE'">
                                          <i class="ph-fill" [ngClass]="operation.type === 'ENTREE' ? 'ph-sign-in' : 'ph-sign-out'"
                                          aria-hidden="true"></i>
                                        </span>
                                        @if (operation.estReelle) {
                                          <span class="badge badge--ghost" title="Opération réelle non pointée">Réelle</span>
                                        }
                                        @if (operation.provision) {
                                          Provision :
                                        }
                                        {{ operation.libelle }}
                                        @if (operation.moyenPaiement === 'CHEQUE' && operation.numeroCheque) {
                                          (C{{ operation.numeroCheque }})
                                        }
                                        @if (operation.provision) {
                                          ({{ formatterMontant(operation.montant) }})
                                        }
                                      </td>
                                      <td>
                                        @if (operation.provision) {
                                          {{ formatterMontant(montantPlanifiePourOperation(operation, periode().annee, periode().mois)) }}
                                        }
                                        @if (!operation.provision) {
                                          {{ formatterMontant(operation.montant) }}
                                        }
                                        @if (!operation.estReelle && operation.moyenPaiement === 'VIREMENT' && !operation.virementProgramme) {
                                          <i
                                            class="ph-fill ph-warning warning-virement"
                                            role="img" aria-label="Virement non programmé sur la banque"
                                          title="Virement non programmé sur la banque"></i>
                                        }
                                      </td>
                                      <td>{{ operation.jourDuMois }}</td>
                                      <td>{{ operation.categorie }}</td>
                                      <td class="actions">
                                        @if (!operation.estReelle) {
                                          <button type="button" class="btn-secondaire btn-with-icon btn-with-icon--warning"
                                            (click)="preparerPointageOperationPlanifiee(operation)">
                                            <i class="ph-fill" [ngClass]="operation.provision ? 'ph-hand-withdraw' : 'ph-check-square'"
                                            aria-hidden="true"></i>
                                          </button>
                                          <button type="button" class="btn-secondaire btn-with-icon btn-with-icon--green"
                                            [class.btn-secondaire--disabled]="operation.provision"
                                            (click)="pointerOperationPlanifieeDirect(operation)" [disabled]="operation.provision">
                                            <i class="ph-fill ph-checks" aria-hidden="true"></i>
                                          </button>
                                          <button type="button" class="btn-secondaire btn-icon"
                                            (click)="editerOperationPlanifiee(operation)" aria-label="Modifier l'opération">
                                            <i class="ph-fill ph-file-magnifying-glass" aria-hidden="true"></i>
                                          </button>
                                          <button type="button" class="btn-danger btn-icon"
                                            (click)="supprimerOperationPlanifiee(operation.id)" aria-label="Supprimer l'opération">
                                            <i class="ph-fill ph-trash" aria-hidden="true"></i>
                                          </button>
                                        }
                                        @if (operation.estReelle) {
                                          <button type="button" class="btn-secondaire btn-with-icon" title="Pointer (valider)"
                                            (click)="pointerOperation(operation.id)">
                                            <i class="ph-fill ph-check" aria-hidden="true"></i>
                                          </button>
                                          <button type="button" class="btn-secondaire btn-icon"
                                            (click)="editerOperationReelle($any(operation))" aria-label="Modifier l'opération réelle">
                                            <i class="ph-fill ph-pencil-simple" aria-hidden="true"></i>
                                          </button>
                                          <button type="button" class="btn-danger btn-icon" (click)="supprimerOperationReelle(operation.id)"
                                            aria-label="Supprimer l'opération réelle">
                                            <i class="ph-fill ph-trash" aria-hidden="true"></i>
                                          </button>
                                        }
                                      </td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          }
                          @if (!chargementPlanifiees() && operationsPlanifieesTrieesEtFiltrees().length === 0 && operationsPlanifiees().length === 0) {
                            <div class="empty-state"
                              >
                              <h3>Aucune opération planifiée</h3>
                              <p>Ajoutez vos prélèvements et virements à venir pour anticiper votre trésorerie.</p>
                              <button type="button" (click)="ouvrirCreationOperationPlanifiee()">Créer une opération</button>
                            </div>
                          }
                          @if (!chargementPlanifiees() && operationsPlanifieesTrieesEtFiltrees().length === 0 && operationsPlanifiees().length > 0) {
                            <div class="empty-state"
                              >
                              <h3>Aucun résultat</h3>
                              <p>Aucune opération ne correspond aux filtres sélectionnés.</p>
                              <button type="button" class="btn-secondaire" (click)="reinitialiserFiltresPlanifiees()">
                                Réinitialiser les filtres
                              </button>
                            </div>
                          }
                          <app-popup-edition-planifiee [operation]="operationPlanifieeEditee()"
                            [visible]="operationPlanifieeFormOuverte()" [erreur]="erreurs()" [categories]="categories()" [moyensPaiement]="moyensPaiement"
                            [comptesDisponibles]="comptesDestinationDisponibles()" (sauvegarder)="onSauvegarderPlanifiee($event)"
                            (annuler)="fermerCanvasOperationPlanifiee()" (supprimer)="supprimerOperationPlanifiee($event)"
                          (ajouterCategorie)="ajouterCategorie()"></app-popup-edition-planifiee>
                        </div>
                        <div class="operations__colonne">
                          <div class="operations__header">
                            <div>
                              <h2>Opérations passées</h2>
                            </div>
                            <div class="operations__header-actions">
                              <button type="button" (click)="ouvrirCreationOperationReelle()">
                                Ajouter une opération réelle
                              </button>
                            </div>
                          </div>
                          @if (chargementReelles()) {
                            <div class="skeleton">Chargement…</div>
                          }
                          @if (operationsReellesTrieesEtFiltrees().length > 0) {
                            <div class="table-wrapper"
                              (click)="fermerTousLesDropdownsReelles()">
                              <table class="tableau" (click)="$event.stopPropagation()">
                                <thead>
                                  <tr>
                                    <th class="th-filtrable">
                                      <div class="th-header" (click)="$event.stopPropagation()">
                                        <span (click)="changerTriReelle('libelle')" class="th-triable">
                                          Libellé
                                          @if (triReelleColonne() === 'libelle') {
                                            <span class="tri-icone">
                                              {{ triReelleOrdre() === 'asc' ? '▲' : '▼' }}
                                            </span>
                                          }
                                        </span>
                                        <button type="button" class="btn-filtre-colonne" [class.actif]="nombreFiltresReelleLibelle() > 0"
                                          (click)="basculerDropdownReelleColonne('libelle')">
                                          🔍
                                          @if (nombreFiltresReelleLibelle() > 0) {
                                            <span class="badge-filtre">{{
                                            nombreFiltresReelleLibelle() }}</span>
                                          }
                                        </button>
                                      </div>
                                      @if (colonneReelleDropdownOuverte() === 'libelle') {
                                        <div class="dropdown-filtre"
                                          (click)="$event.stopPropagation()">
                                          <div class="dropdown-filtre__content">
                                            <input type="text" placeholder="Rechercher..." [value]="filtreReelleLibelleTexte()"
                                              (input)="filtreReelleLibelleTexte.set($any($event.target).value)"
                                              (keydown.enter)="fermerTousLesDropdownsReelles()" class="dropdown-filtre__input" />
                                              <button type="button" class="dropdown-filtre__reset"
                                                (click)="reinitialiserFiltreReelleColonne('libelle')"
                                                [disabled]="nombreFiltresReelleLibelle() === 0">
                                                Réinitialiser
                                              </button>
                                            </div>
                                          </div>
                                        }
                                      </th>
                                      <th class="th-filtrable">
                                        <div class="th-header">
                                          <span (click)="changerTriReelle('montant')" class="th-triable">
                                            Montant
                                            @if (triReelleColonne() === 'montant') {
                                              <span class="tri-icone">
                                                {{ triReelleOrdre() === 'asc' ? '▲' : '▼' }}
                                              </span>
                                            }
                                          </span>
                                          <button type="button" class="btn-filtre-colonne" [class.actif]="nombreFiltresReelleMontant() > 0"
                                            (click)="basculerDropdownReelleColonne('montant')">
                                            🔍
                                            @if (nombreFiltresReelleMontant() > 0) {
                                              <span class="badge-filtre">{{
                                              nombreFiltresReelleMontant() }}</span>
                                            }
                                          </button>
                                        </div>
                                        @if (colonneReelleDropdownOuverte() === 'montant') {
                                          <div class="dropdown-filtre"
                                            (click)="$event.stopPropagation()">
                                            <div class="dropdown-filtre__content">
                                              <label>
                                                <span>Min</span>
                                                <input type="text" appMontant placeholder="Montant min" [ngModel]="filtreReelleMontantMin()" [ngModelOptions]="{standalone: true}"
                                                  (ngModelChange)="filtreReelleMontantMin.set($event)"
                                                  (keydown.enter)="fermerTousLesDropdownsReelles()" />
                                                </label>
                                                <label>
                                                  <span>Max</span>
                                                  <input type="text" appMontant placeholder="Montant max" [ngModel]="filtreReelleMontantMax()" [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="filtreReelleMontantMax.set($event)"
                                                    (keydown.enter)="fermerTousLesDropdownsReelles()" />
                                                  </label>
                                                  <label>
                                                    <span>Type</span>
                                                    <select [value]="filtreReelleMontantType()"
                                                      (change)="filtreReelleMontantType.set($any($event.target).value)"
                                                      (keydown.enter)="fermerTousLesDropdownsReelles()">
                                                      <option value="TOUS">● Tous</option>
                                                      <option value="ENTREE">○ Entrées</option>
                                                      <option value="SORTIE">○ Sorties</option>
                                                    </select>
                                                  </label>
                                                  <button type="button" class="dropdown-filtre__reset"
                                                    (click)="reinitialiserFiltreReelleColonne('montant')"
                                                    [disabled]="nombreFiltresReelleMontant() === 0">
                                                    Réinitialiser
                                                  </button>
                                                </div>
                                              </div>
                                            }
                                          </th>
                                          <th class="th-filtrable">
                                            <div class="th-header">
                                              <span (click)="changerTriReelle('date')" class="th-triable">
                                                Date d'opération
                                                @if (triReelleColonne() === 'date') {
                                                  <span class="tri-icone">
                                                    {{ triReelleOrdre() === 'asc' ? '▲' : '▼' }}
                                                  </span>
                                                }
                                              </span>
                                              <button type="button" class="btn-filtre-colonne" [class.actif]="nombreFiltresReelleDate() > 0"
                                                (click)="basculerDropdownReelleColonne('date')">
                                                🔍
                                                @if (nombreFiltresReelleDate() > 0) {
                                                  <span class="badge-filtre">{{ nombreFiltresReelleDate()
                                                  }}</span>
                                                }
                                              </button>
                                            </div>
                                            @if (colonneReelleDropdownOuverte() === 'date') {
                                              <div class="dropdown-filtre"
                                                (click)="$event.stopPropagation()">
                                                <div class="dropdown-filtre__content">
                                                  <input type="date" [value]="filtreReelleDate()"
                                                    (input)="filtreReelleDate.set($any($event.target).value)"
                                                    (keydown.enter)="fermerTousLesDropdownsReelles()" class="dropdown-filtre__input" />
                                                    <button type="button" class="dropdown-filtre__reset"
                                                      (click)="reinitialiserFiltreReelleColonne('date')"
                                                      [disabled]="nombreFiltresReelleDate() === 0">
                                                      Réinitialiser
                                                    </button>
                                                  </div>
                                                </div>
                                              }
                                            </th>
                                            <th>Date de valeur</th>
                                            <th class="th-filtrable">
                                              <div class="th-header">
                                                <span (click)="changerTriReelle('statut')" class="th-triable">
                                                  Statut
                                                  @if (triReelleColonne() === 'statut') {
                                                    <span class="tri-icone">
                                                      {{ triReelleOrdre() === 'asc' ? '▲' : '▼' }}
                                                    </span>
                                                  }
                                                </span>
                                                <button type="button" class="btn-filtre-colonne" [class.actif]="nombreFiltresReelleStatut() > 0"
                                                  (click)="basculerDropdownReelleColonne('statut')">
                                                  🔍
                                                  @if (nombreFiltresReelleStatut() > 0) {
                                                    <span class="badge-filtre">{{
                                                    nombreFiltresReelleStatut() }}</span>
                                                  }
                                                </button>
                                              </div>
                                              @if (colonneReelleDropdownOuverte() === 'statut') {
                                                <div class="dropdown-filtre"
                                                  (click)="$event.stopPropagation()">
                                                  <div class="dropdown-filtre__content">
                                                    <select [value]="filtreReelleStatut()"
                                                      (change)="filtreReelleStatut.set($any($event.target).value)"
                                                      (keydown.enter)="fermerTousLesDropdownsReelles()" class="dropdown-filtre__input">
                                                      <option value="TOUS">● Tous</option>
                                                      <option value="POINTEE">○ Pointée</option>
                                                      <option value="A_POINTER">○ À pointer</option>
                                                    </select>
                                                    <button type="button" class="dropdown-filtre__reset"
                                                      (click)="reinitialiserFiltreReelleColonne('statut')"
                                                      [disabled]="nombreFiltresReelleStatut() === 0">
                                                      Réinitialiser
                                                    </button>
                                                  </div>
                                                </div>
                                              }
                                            </th>
                                            <th class="col-actions">Actions</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          @for (operation of operationsReellesTrieesEtFiltrees(); track operation) {
                                            <tr>
                                              <td>
                                                <span class="type-chip" [class.type-chip--entree]="operation.type === 'ENTREE'"
                                                  [class.type-chip--sortie]="operation.type === 'SORTIE'">
                                                  <i class="ph-fill" [ngClass]="operation.type === 'ENTREE' ? 'ph-sign-in' : 'ph-sign-out'"
                                                  aria-hidden="true"></i>
                                                </span>{{ operation.libelle }}
                                                @if (operation.moyenPaiement === 'CHEQUE' && operation.numeroCheque) {
                                                  (C{{ operation.numeroCheque }})
                                                }
                                              </td>
                                              <td>{{ formatterMontant(operation.montant) }}</td>
                                              <td>{{ operation.dateOperation | date: 'dd/MM/yyyy' }}</td>
                                              <td>{{ operation.dateValeur ? (operation.dateValeur | date: 'dd/MM/yyyy') : '—' }}</td>
                                              <td>
                                                <span class="status-pill" [class.status-pill--ok]="operation.estPointee">
                                                  {{ operation.estPointee ? 'Pointée' : 'À pointer' }}
                                                </span>
                                              </td>
                                              <td class="actions">
                                                <button type="button" class="btn-secondaire btn-with-icon btn-with-icon--warning"
                                                  (click)="pointerOperation(operation.id)" [disabled]="operation.estPointee"
                                                  aria-label="Pointer l'opération réelle">
                                                  <i class="ph-fill ph-check-square" aria-hidden="true"></i>
                                                </button>
                                                <button type="button" class="btn-secondaire btn-icon" (click)="editerOperationReelle(operation)"
                                                  aria-label="Modifier l'opération réelle">
                                                  <i class="ph-fill ph-file-magnifying-glass" aria-hidden="true"></i>
                                                </button>
                                                <button type="button" class="btn-danger btn-icon" (click)="supprimerOperationReelle(operation.id)"
                                                  aria-label="Supprimer l'opération réelle">
                                                  <i class="ph ph-trash" aria-hidden="true"></i>
                                                </button>
                                              </td>
                                            </tr>
                                          }
                                        </tbody>
                                      </table>
                                    </div>
                                  }
                                  @if (!chargementReelles() && operationsReelles().length === 0) {
                                    <div class="empty-state">
                                      <h3>Aucune opération réelle</h3>
                                      <p>Saisissez vos dépenses et revenus pour suivre l’écart avec le planifié.</p>
                                      <button type="button" (click)="ouvrirCreationOperationReelle()">Ajouter une opération réelle</button>
                                    </div>
                                  }
                                  @if (!chargementReelles() && operationsReellesTrieesEtFiltrees().length === 0 && operationsReelles().length > 0) {
                                    <div class="empty-state"
                                      >
                                      <h3>Aucun résultat</h3>
                                      <p>Aucune opération ne correspond aux filtres sélectionnés.</p>
                                      <button type="button" class="btn-secondaire" (click)="reinitialiserFiltresReelles()">
                                        Réinitialiser les filtres
                                      </button>
                                    </div>
                                  }
                                  @if (operationReelleFormOuverte()) {
                                    <div class="canvas-pointage canvas-operation-reelle">
                                      <div class="canvas-pointage__overlay" (click)="fermerCanvasOperationReelle()"></div>
                                      <div class="canvas-pointage__panel canvas-operation-reelle__panel" role="dialog" aria-modal="true">
                                        <div class="canvas-operation-reelle__header">
                                          <div>
                                            <p class="canvas-operation-reelle__eyebrow">
                                              {{ operationReelleEditee() ? 'Edition' : 'Nouvelle opération' }}
                                            </p>
                                            <h3>
                                              {{ operationReelleEditee() ? "Modifier l'opération réelle" : "Ajouter une opération réelle" }}
                                            </h3>
                                          </div>
                                          <button type="button" class="canvas-operation-reelle__close" aria-label="Fermer le formulaire"
                                            (click)="fermerCanvasOperationReelle()">
                                            &times;
                                          </button>
                                        </div>
                                        @if (operationReelleEditee()) {
                                          <p class="texte-secondaire">
                                            Modification de {{ operationReelleEditee()?.libelle }} - cliquez sur Annuler pour revenir à l'ajout.
                                          </p>
                                        }
                                        <form [formGroup]="operationReelleForm" (ngSubmit)="soumettreOperationReelle()"
                                          class="formulaire canvas-operation-reelle__form">
                                          <section class="canvas-operation-reelle__section">
                                            <div class="canvas-operation-reelle__section-header">
                                              <div>
                                                <h4>Informations générales</h4>
                                                <p>Libellé, type et catégorie</p>
                                              </div>
                                              @if (operationReelleEditee()) {
                                                <span class="canvas-operation-reelle__badge">
                                                  Edition
                                                </span>
                                              } @else {
                                                <span class="canvas-operation-reelle__badge canvas-operation-reelle__badge--info">
                                                  Création
                                                </span>
                                              }
                                            </div>
                                            <div class="canvas-operation-reelle__grid">
                                              <label class="canvas-operation-reelle__field canvas-operation-reelle__field--full">
                                                Libellé
                                                <input type="text" formControlName="libelle" autofocus />
                                              </label>
                                              <label class="canvas-operation-reelle__field">
                                                Type
                                                <select formControlName="type">
                                                  <option value="ENTREE">Entrée</option>
                                                  <option value="SORTIE">Sortie</option>
                                                </select>
                                              </label>
                                              <label class="canvas-operation-reelle__field categorie-select">
                                                Catégorie
                                                <div class="categorie-select__row">
                                                  <select formControlName="categorie">
                                                    <option value="">Aucune</option>
                                                    @for (categorie of categories(); track categorie) {
                                                      <option [value]="categorie.nom">
                                                        {{ categorie.nom }}
                                                      </option>
                                                    }
                                                  </select>
                                                  <button type="button" class="btn-ajout-categorie" aria-label="Ajouter une catégorie"
                                                    (click)="ajouterCategorie()">
                                                    +
                                                  </button>
                                                </div>
                                              </label>
                                              <label class="canvas-operation-reelle__field canvas-operation-reelle__field--full">
                                                Opération planifiée liée
                                                @if (operationReelleEditee(); as opReelle) {
                                                  @if (opReelle.operationPlanifieeId !== null) {
                                                    <div class="planifiee-liee-lecture">
                                                      {{ libelleOperationPlanifieePourOperation(opReelle) }}
                                                    </div>
                                                  } @else {
                                                    <select formControlName="operationPlanifieeId">
                                                      <option [ngValue]="null">Aucune</option>
                                                      @for (planifiee of operationsPlanifiees(); track planifiee) {
                                                        <option [ngValue]="planifiee.id">
                                                          {{ planifiee.libelle }}
                                                        </option>
                                                      }
                                                    </select>
                                                  }
                                                } @else {
                                                  <select formControlName="operationPlanifieeId">
                                                    <option [ngValue]="null">Aucune</option>
                                                    @for (planifiee of operationsPlanifiees(); track planifiee) {
                                                      <option [ngValue]="planifiee.id">
                                                        {{ planifiee.libelle }}
                                                      </option>
                                                    }
                                                  </select>
                                                }
                                              </label>
                                            </div>
                                          </section>
                                          <section class="canvas-operation-reelle__section">
                                            <div class="canvas-operation-reelle__section-header">
                                              <div>
                                                <h4>Montant & statut</h4>
                                                <p>Saisissez le montant réel et son pointage</p>
                                              </div>
                                            </div>
                                            <div class="canvas-operation-reelle__grid">
                                              <label class="canvas-operation-reelle__field">
                                                Montant
                                                <input #operationReelleMontantInput type="text" appMontant formControlName="montant" />
                                              </label>
                                              <label class="canvas-operation-reelle__field">
                                                Date d'opération
                                                <input type="date" formControlName="dateOperation" />
                                              </label>
                                              <label class="canvas-operation-reelle__field">
                                                Date de valeur
                                                <input type="date" formControlName="dateValeur" />
                                              </label>
                                              <label class="canvas-operation-reelle__field canvas-operation-reelle__field--checkbox">
                                                <span>Statut</span>
                                                <div class="checkbox">
                                                  <input type="checkbox" formControlName="estPointee" />
                                                  Déjà pointée
                                                </div>
                                              </label>
                                            </div>
                                          </section>
                                          <section class="canvas-operation-reelle__section">
                                            <div class="canvas-operation-reelle__section-header">
                                              <div>
                                                <h4>Moyen de paiement</h4>
                                                <p>Précisez la provenance des fonds</p>
                                              </div>
                                            </div>
                                            <div class="canvas-operation-reelle__grid">
                                              <label class="canvas-operation-reelle__field canvas-operation-reelle__field--moyen">
                                                Moyen de paiement
                                                <select formControlName="moyenPaiement">
                                                  <option [ngValue]="null">Aucun</option>
                                                  @for (moyen of moyensPaiement; track moyen) {
                                                    <option [ngValue]="moyen.value">
                                                      {{ moyen.label }}
                                                    </option>
                                                  }
                                                </select>
                                              </label>
                                              @if (operationReelleForm.get('moyenPaiement')?.value === 'CHEQUE') {
                                                <label class="canvas-operation-reelle__field"
                                                  >
                                                  Numéro de chèque
                                                  <input type="text" formControlName="numeroCheque" />
                                                </label>
                                              }
                                              @if (operationReelleForm.get('moyenPaiement')?.value === 'VIREMENT') {
                                                <label class="canvas-operation-reelle__field"
                                                  >
                                                  Compte destination
                                                  <select formControlName="compteDestinationId"
                                                    [disabled]="operationReelleForm.get('moyenPaiement')?.value !== 'VIREMENT'">
                                                    <option [ngValue]="null">Sélectionner un compte</option>
                                                    @for (compteOption of comptesDestinationDisponibles(); track compteOption) {
                                                      <option
                                                        [ngValue]="compteOption.id">
                                                        {{ compteOption.nom }}
                                                      </option>
                                                    }
                                                  </select>
                                                </label>
                                              }
                                            </div>
                                          </section>
                                          <div class="form-actions canvas-operation-reelle__actions">
                                            <button type="submit">
                                              {{ operationReelleEditee() ? "Mettre à jour" : "Ajouter" }}
                                            </button>
                                            <button type="button" class="btn-secondaire" (click)="annulerEditionOperationReelle()">
                                              Annuler
                                            </button>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </section>
                            }
                          </main>
                        </div>
                      }

                      @if (!compteSelectionne()) {
                        <div class="aucun-compte">
                          <p class="texte-secondaire">
                            Sélectionnez ou créez un compte pour commencer à suivre vos opérations.
                          </p>
                        </div>
                      }

                      <footer class="app__footer">
                        Version {{ appVersion }} &ndash; {{ dateDuJour | date: 'EEEE d MMMM y' }}
                      </footer>
                    </div>
